import { GridPropetryEditor } from "./GridPropetryEditor";

export default GridPropetryEditor;